import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function LegalShell({ title, updated, path, description, children }) {
  return (
    <div className="min-h-screen bg-linen text-ink">
      <SEO title={title} path={path} description={description || `${title} — Viyora Tech. Last updated ${updated}.`} />
      <header className="container-lg py-6 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2">
          <img src="/viyora-icon-64.png" alt="Viyora" className="w-9 h-9 " />
          <span className="font-display text-xl tracking-tight">Viyora</span>
        </Link>
        <Link to="/" className="text-sm text-ink-mid hover:text-ink">← Back to home</Link>
      </header>

      <main className="container-lg py-12 max-w-3xl">
        <span className="overline text-ink-soft">Legal</span>
        <h1 className="mt-2 font-display text-4xl md:text-5xl tracking-tight">{title}</h1>
        <p className="mt-3 text-sm text-ink-mid">Last updated: {updated}</p>

        <article className="prose prose-pine mt-10 max-w-none [&_h2]:font-display [&_h2]:text-2xl [&_h2]:tracking-tight [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-[15px] [&_p]:leading-relaxed [&_p]:text-ink/80 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:text-[15px] [&_ul]:text-ink/80 [&_ul]:space-y-1 [&_a]:text-ink [&_a]:underline">
          {children}
        </article>
      </main>

      <footer className="bg-pine text-linen mt-20">
        <div className="container-lg py-8 text-center text-xs text-linen/60">
          © 2026 Viyora Tech · <Link to="/legal/privacy" className="hover:text-linen">Privacy</Link> · <Link to="/legal/terms" className="hover:text-linen">Terms</Link> · <Link to="/legal/dpdp" className="hover:text-linen">DPDP Compliance</Link> · <Link to="/legal/limited-use" className="hover:text-linen" data-testid="footer-limited-use-link">Limited Use</Link>
        </div>
      </footer>
    </div>
  );
}
